import type { CanonicalId } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const productAbbreviations: Record<CanonicalId, string> = {
	'jira-software': 'jsw',
	'jira-servicedesk': 'jsm',
	'jira-product-discovery': 'jpd',
	'jira-customer-service': 'jcs',
	'jira-core': 'jwm',
	jira: 'jira',
} as const;
